module.exports = __webpack_public_path__ + "img/slider-accueil-knett-hamburger.f7cc91d6.jpg";